import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Silent } from "@/__main__/data-model.mjs";

const columnModel = {
  name: String,
  position: Number,
  typeName: String,
  typeText: String,
};

const ChampionResult = {
  champion_id: Number,
  championId: Number,
  stats: {
    top_4_percent: Number,
    tier: Number,
    top_teammates: [
      {
        top_4_percent: Number,
        tier: Number,
        teammate_champion_id: Number,
        top_1_percent: Number,
        num_duos: Number,
        teammate_rank: Number,
        num_games: Number,
        pick_rate: Number,
        avg_placement: Number,
        top_2_percent: Number,
      },
    ],
    match_pick_rate: Number,
    top_1_percent: Number,
    num_duos: Number,
    num_games: Number,
    pick_rate: Number,
    avg_placement: Number,
    ban_rate: Number,
    top_2_percent: Number,
  },
  patch: String,
  dt: String,
  dummy: String,
} satisfies ModelDefinition;

const ChampionsModel = createModel({
  data: {
    executeDatabricksQuery: {
      payload: {
        manifest: {
          schema: {
            columnCount: Number,
            columns: [columnModel],
          },
        },
        result: {
          chunkIndex: Silent(Number),
          dataArray: [[String]],
          rowCount: Silent(Number),
          rowOffset: Silent(Number),
        },
      },
    },
  },
}).transform([ChampionResult], (data) => {
  const {
    data: { executeDatabricksQuery },
  } = data;

  const { columns = [] } =
    executeDatabricksQuery?.payload?.manifest?.schema || {};

  const list = executeDatabricksQuery?.payload?.result?.dataArray || [];

  const champions = list.map((c) => {
    const result = {
      champion_id: 0,
      championId: 0,
      stats: {
        top_4_percent: 0,
        tier: 0,
        top_teammates: [],
        match_pick_rate: 0,
        top_1_percent: 0,
        num_duos: 0,
        num_games: 0,
        pick_rate: 0,
        avg_placement: 0,
        ban_rate: 0,
        top_2_percent: 0,
      },
      patch: "",
      dt: "",
      dummy: "",
    };
    for (const column of columns) {
      if (!result.hasOwnProperty(column.name)) continue;
      const value: string = (c[column.position] || "") as unknown as string;
      result[column.name] = castType(column.typeName, value);
    }

    result.championId = result.champion_id;

    return result;
  });

  return champions;
});

export default ChampionsModel;

export type ArenaChampionsStats = FromModel<typeof ChampionsModel>;
export type ArenaChampionStats = ArenaChampionsStats[number];

function castType(typeText: string, value: string) {
  switch (typeText) {
    case "BOOLEAN":
      return value === "true";
    case "DOUBLE":
    case "BIGINT":
    case "LONG":
    case "INT":
      return value ? Number(value) : 0;
    case "MAP":
      return value ? JSON.parse(value) : {};
    case "ARRAY":
      return value ? JSON.parse(value) : [];
    case "STRUCT":
      return value ? JSON.parse(value) : {};
    case "STRING":
    case undefined:
    default:
      return value ?? "";
  }
}
